import {SignableDocumentType, SpouseSigningMode} from "@/constants/SignatureConstants";
import FileMetaDTO from "@/dto/files/FileMetaDTO";

export default class AuthFormPayload {
    file: FileMetaDTO | null = null;
    type: SignableDocumentType | null = null;
    spouseSigningMode: SpouseSigningMode | null = null;
}